import { request } from "@/api";
import type { InitData } from "@/shared/types";

export const fetchInit = () => {
  return request<InitData>("/init");
};
